module.exports = __webpack_public_path__ + "static/media/Standup-Sprint-4-Audio-1.790e55d7.mp3";